import { Pipe, PipeTransform } from '@angular/core';
import { Player } from 'src/models/player.model';

@Pipe({
   name: 'score'
})
export class TournamentScorePipe implements PipeTransform {
   constructor() { }
   transform(round: { player: Player, score: string }[], idx: number) {
      if (round === undefined) return "";
      let p = round[idx];
      if (p != null) {
         return p.score;
      }
      return "";
   }
}